import { LINK_TITLE } from '../elements/link'

export const CONTENT_BLOCK = `
...on contentBlock_Entry {
  id
  typeHandle

  content: contentBlock { html }

  ${ LINK_TITLE }
}
`
